import { Paginator } from "primereact/paginator";

const STATUS_STYLES = {
  Active:   "bg-green-100 text-green-800",
  Upcoming: "bg-blue-100 text-blue-800",
  Expired:  "bg-red-100 text-red-800",
};

const BannerMobileCard = ({
  paginatedData,
  banners,
  page,
  setPage,
  rowsPerPage,
  onCardClick,
  dateTemplate,
  getStatus,
  API_BASE,
}) => (
  <div className="pb-4">
    {paginatedData.length === 0 ? (
      <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
        <p className="text-gray-500 text-sm">No banners found</p>
      </div>
    ) : (
      paginatedData.map((banner) => {
        const status = getStatus(banner.startDate, banner.endDate, banner.visible);
        return (
          <div
            key={banner._id}
            onClick={() => onCardClick(banner)}
            className="bg-white rounded-xl border border-gray-200 shadow-sm mb-4 overflow-hidden cursor-pointer hover:shadow-md transition-shadow duration-200"
          >
            {/* Banner image */}
            <img
              src={`${API_BASE}/${banner.imagePath}`}
              alt="Banner"
              className="w-full h-40 object-cover"
            />

            <div className="p-4">
              {banner.description && (
                <p className="text-sm font-semibold text-gray-800 mb-3">{banner.description}</p>
              )}

              <div className="border-t border-gray-100 pt-3 grid grid-cols-2 gap-3 mb-3">
                <div>
                  <p className="text-xs text-gray-400 mb-1">Start Date</p>
                  <p className="text-sm font-medium text-gray-700">{dateTemplate(banner.startDate)}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-400 mb-1">End Date</p>
                  <p className="text-sm font-medium text-gray-700">{dateTemplate(banner.endDate)}</p>
                </div>
              </div>

              <div className="border-t border-gray-100 pt-3 flex justify-center">
                <span className={`px-4 py-1.5 rounded-full text-xs font-semibold ${STATUS_STYLES[status] || "bg-gray-100 text-gray-600"}`}>
                  {status}
                </span>
              </div>
            </div>
          </div>
        );
      })
    )}

    {banners.length > rowsPerPage && (
      <div className="sticky bottom-0 bg-white border-t border-gray-200 z-10">
        <Paginator
          first={(page - 1) * rowsPerPage}
          rows={rowsPerPage}
          totalRecords={banners.length}
          onPageChange={(e) => {
            const newPage = e.page + 1;
            if (newPage !== page) setPage(newPage);
          }}
          template="PrevPageLink PageLinks NextPageLink"
        />
      </div>
    )}
  </div>
);

export default BannerMobileCard;
